// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"21":"6b306d79","101":"31d6cfe0","150":"3d6aa211","205":"a713f4eb","255":"209d5402","506":"a8309e84","675":"38f25849"}[chunkId] + ".chunk.css";
};